import React from "react";
import { useDraggableSheet } from "../../../helpers/hooks";
import './DeleteNews.scss'

const DeleteNews = ({ onClose, onDelete }) => {

    const {
        sheetStyle,
        overlayHandlers,
    } = useDraggableSheet({ onClose })



    return (
        <div className="delete-container-news" {...overlayHandlers}>
            <div className="sheet txt-ac px-16" style={sheetStyle} onClick={(e) => e.stopPropagation()}>
                <p className="fs-sm2 mt-32 mb-24 fg-dark fw-bold">Delete this news?</p>
                <div>
                    <button className="btn red-outline-btn btn-full aic jcc fw-extra-bold mb-24"
                        style={{ height: '64px' }}

                        onClick={onDelete}>Yes, delete</button>
                    <p className="fs-xxs fg-dark fw-bold mb-16 mt-0 c-pointer td-underline" onClick={onClose}>CANCEL</p>
                </div>
            </div>
        </div>
    )
}

export default DeleteNews